module.exports = {"id":"194053","name":"Lasse Sobiech","rating":"75","photo":"./data/images/photos/2/194053.png","club":{"name":"FC St. Pauli","logo":"./data/images/clubs/FCSt.Pauli.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LasseSobiech0.json
// module id = 2434
// module chunks = 0